import {
  SidebarMenu,
  SidebarMenuItem,
} from "~/components/ui/sidebar"

export function TeamSwitcher() {



  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <div className={'flex justify-center w-full'}>
          <div className="flex aspect-square size-12 items-center justify-center rounded-lg">
            <img src={'/logo.svg'} />
          </div>
        </div>
      </SidebarMenuItem>
    </SidebarMenu>
  )
}
